import { FooterApiResponse, FooterModel } from '@/types/footer';
import { getDictValue } from '@/lib/utils/dictMapper';

export function mapFooterFromApi(apiData: FooterApiResponse): FooterModel {
  return {
    partners: apiData.partners,
    company: apiData.company,
    links: apiData.links,
    contact: apiData.contact,
    social: apiData.social,
    legal: apiData.legal,
    layout: apiData.layout,
    styling: apiData.styling
  };
}

export function mapFooterFromApiWithDict(apiData: FooterApiResponse, dict: any): FooterModel {
  return {
    partners: apiData.partners ? {
      title: getDictValue(dict, apiData.partners.title),
      logos: apiData.partners.logos.map(logo => ({
        ...logo,
        alt: getDictValue(dict, logo.alt)
      }))
    } : undefined,
    company: {
      name: getDictValue(dict, apiData.company.name),
      description: getDictValue(dict, apiData.company.description),
      logo: {
        src: apiData.company.logo.src,
        alt: getDictValue(dict, apiData.company.logo.alt)
      }
    },
    links: {
      quickLinks: apiData.links.quickLinks.map(link => ({
        ...link,
        text: getDictValue(dict, link.text)
      }))
    },
    contact: {
      phone: getDictValue(dict, apiData.contact.phone),
      email: getDictValue(dict, apiData.contact.email),
      address: getDictValue(dict, apiData.contact.address)
    },
    social: {
      platforms: apiData.social.platforms.map(platform => ({
        ...platform,
        name: getDictValue(dict, platform.name)
      }))
    },
    legal: {
      copyright: getDictValue(dict, apiData.legal.copyright),
      privacy: getDictValue(dict, apiData.legal.privacy),
      terms: getDictValue(dict, apiData.legal.terms),
      cookies: getDictValue(dict, apiData.legal.cookies)
    },
    layout: apiData.layout,
    styling: apiData.styling
  };
}